(function () {
  class FreeSpinsMeter extends PIXI.Container {
    constructor() {
      super();

      this.freeSpinsAwarded = 0;
      this.currentFreeSpin = 0;
    }

    initialise() {
      this.fsContainer = resourceManager.getContainer('freeSpinsContainer');
      this.fsMeterText = resourceManager.get('freeSpinsMeterContainer:freeSpinsMeter:panel:freeSpinsPanelText');
    }

    resetMeter() {
      this.freeSpinsAwarded = 0;
      this.currentFreeSpin = 0;
      this.fsMeterText.setTranslationParameters(this.currentFreeSpin, this.freeSpinsAwarded);
    }

    async hideMeter(instant = false) {
      if (instant !== true) {
        await game.tweenFromToAsync(
          this.fsContainer,
          {
            alpha: 1,
          },
          {
            alpha: 0,
            duration: 0.25,
            ease: 'none',
          }
        );
      }
      this.fsContainer.visible = false;
    }

    async showMeter(instant = false) {
      this.fsContainer.visible = true;
      if (instant !== true) {
        await game.tweenFromToAsync(
          this.fsContainer,
          {
            alpha: 0,
          },
          {
            alpha: 1,
            duration: 0.25,
            ease: 'none',
          }
        );
      }
      this.fsContainer.alpha = 1;
    }

    addSpins(numFs, instant = true) {
      this.freeSpinsAwarded = this.freeSpinsAwarded + numFs;
      this.fsMeterText.setTranslationParameters(this.currentFreeSpin, this.freeSpinsAwarded);
    }

    useSpin() {
      this.currentFreeSpin++;
      this.fsMeterText.setTranslationParameters(this.currentFreeSpin, this.freeSpinsAwarded);
    }
  }

  create = function (json) {
    return new FreeSpinsMeter();
  };

  initialise = function (json, container, resources) {};

  getFilesRequired = function (json) {
    return [''];
  };

  resourceManager.registerObjectType('FreeSpinsMeter', create, initialise, getFilesRequired);
})();
